module.exports = __webpack_public_path__ + "static/video1-aebb5462ff8243fa2a862a8f12450877.mp4";